import { render, staticRenderFns } from "./RelatorioLogAcompanhamentoTurma.vue?vue&type=template&id=6627b448"
import script from "./RelatorioLogAcompanhamentoTurma.vue?vue&type=script&lang=js"
export * from "./RelatorioLogAcompanhamentoTurma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports